import { AiStarGradient as AiStarGradientIcon } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { useReasoningAgent } from '../../hooks/useReasoningAgent.jsx';
import { AgentLabel } from '../messages/AiMessage/AgentLabel.jsx';
import { MarkdownTextAi } from '../messages/UserMessage/Markdown/MarkdownText.jsx';

type Props = {
  reasoningData: Chat.AiChatMessageRecordType[] | undefined;
};

const ReasoningStepsLoader = ({ reasoningData }: Props) => {
  const long1Variant = typographyVariants({
    variant: 'bodyLong01',
  });
  const short1Variant = typographyVariants({
    variant: 'helperText01',
    color: 'secondary',
  });

  const { reasoningAgent } = useReasoningAgent({
    isAiProcessingText: true,
    reasoningMessages: reasoningData || [],
  });

  return (
    <div
      className="flex flex-col gap-2 p-3"
      aria-label="reasoning-steps-loader"
    >
      {reasoningAgent?.agentName && (
        <AgentLabel
          labelDirection="column"
          avatarSize="small"
          agentName={reasoningAgent?.agentName}
        />
      )}
      <div className="flex flex-row gap-2">
        <div className="h-12">
          <AiStarGradientIcon className="animate-[spin_1s_ease-in-out_infinite]" />
        </div>
        {reasoningData && (
          <div className="space-y-2">
            {reasoningData.map(({ message, messageId }, i) => {
              const {
                additionalMetadata: { eventType },
                content,
              } = message;

              const isMsgLast = i === reasoningData.length - 1;

              return (
                <div
                  key={messageId}
                  className={cn(
                    eventType === 'action' ? short1Variant : long1Variant,
                    isMsgLast && 'animate-pulse text-text-info',
                  )}
                >
                  <MarkdownTextAi text={content} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export { ReasoningStepsLoader };
